import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEdit, faStar as faSolidStar} from "@fortawesome/free-solid-svg-icons";
import { faStar as faRegularStar } from "@fortawesome/free-regular-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import API from "../../services/API";
import {toast} from "react-toastify";
import Toast from "../Common/Toast";

const RateRequest = () => {
    const { id } = useParams();
    const [rating, setRating] = useState(0);
    const [rating2, setRating2] = useState(0);
    const [rating3, setRating3] = useState(0);
    const [hover, setHover] = useState(0);
    const [hover2, setHover2] = useState(0);
    const [hover3, setHover3] = useState(0);
    const [comment, setComment] = useState("");

    const handleSubmit = (e) => {

        e.preventDefault();

        const finalRate = ((rating * 1.5) + (rating2 * 2.5) + rating3) / 5

        if (rating < 1 || rating2 < 1 || rating3 < 1) {
            toast.error ('وارد کردن تمامی امتیازها الزامی است');
            return false;
        }



        // داده‌های جمع‌آوری شده:
        const data = {
            id,
            rating : finalRate,
            comment,
        };

        API.storeRate(data)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout (() => {
                    window.location.replace('/requests/1')
                },1500)

            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });

    };

    return (
        <div className="container mt-5 pt-5 text-center" >
            <Toast  />
            <div className="row bg-white py-5 rounded" style={{ maxWidth: 500, margin:  '0 auto' }}>
                <h4 className="mb-4 fw-bold">
                    امتیاز به عملکرد راننده
                </h4>
                <form onSubmit={handleSubmit}>
                    <div className="my-3">
                        <label className='rtl small'>حضور سروقت و بارگیری  </label>
                        <div className='mt-3'>
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                    key={star}
                                    style={{cursor: "pointer", fontSize: 30, color: "#ffc107"}}
                                    onClick={() => setRating(star)}
                                    onMouseEnter={() => setHover(star)}
                                    onMouseLeave={() => setHover(0)}
                                >
                <FontAwesomeIcon
                    icon={(hover || rating) >= star ? faSolidStar : faRegularStar}
                />
              </span>
                            ))}
                        </div>
                    </div>
                    <div className="my-3">
                        <label className='rtl small'>تخلیه به موقع    </label>
                        <div className='mt-3'>
                            {[1, 2, 3, 4, 5].map((star2) => (
                                <span
                                    key={star2}
                                    style={{cursor: "pointer", fontSize: 30, color: "#ffc107"}}
                                    onClick={() => setRating2(star2)}
                                    onMouseEnter={() => setHover2(star2)}
                                    onMouseLeave={() => setHover2(0)}
                                >
                <FontAwesomeIcon
                    icon={(hover2 || rating2) >= star2 ? faSolidStar : faRegularStar}
                />
              </span>
                            ))}
                        </div>
                    </div>
                    <div className="my-3">
                        <label className='rtl small'>پاسخگوئی و رعایت اخلاق    </label>
                        <div className='mt-3'>
                            {[1, 2, 3, 4, 5].map((star3) => (
                                <span
                                    key={star3}
                                    style={{cursor: "pointer", fontSize: 30, color: "#ffc107"}}
                                    onClick={() => setRating3(star3)}
                                    onMouseEnter={() => setHover3(star3)}
                                    onMouseLeave={() => setHover3(0)}
                                >
                <FontAwesomeIcon
                    icon={(hover3 || rating3) >= star3 ? faSolidStar : faRegularStar}
                />
              </span>
                            ))}
                        </div>
                    </div>
                    <div className="mb-3 rtl text-end">
                        <label htmlFor="comment" className="form-label super-small">
                            <FontAwesomeIcon icon={faEdit} className='mx-2' />
                            نظر شما:</label>
                        <textarea
                            id="comment"
                            className="form-control"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            rows={3}
                        />
                    </div>
                    <button type="submit" className="btn btn-warning w-50">ثبت نظر</button>
                </form>
            </div>
        </div>
    );
};

export default RateRequest;
